import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
  class: "function-bar"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  const _component_Breadcrumb = _resolveComponent("Breadcrumb");
  const _component_ViewMode = _resolveComponent("ViewMode");
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item");
  const _component_el_skeleton = _resolveComponent("el-skeleton");
  const _component_el_divider = _resolveComponent("el-divider");
  const _component_List = _resolveComponent("List");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createVNode(_component_router_link, {
    to: {
      params: {
        path: [$setup.productRootPath]
      }
    }
  }, {
    default: _withCtx(() => [_createElementVNode("img", {
      class: "logo",
      src: $setup.logo
    }, null, 8, _hoisted_1)]),
    _: 1
  }, 8, ["to"]), _createElementVNode("div", _hoisted_2, [_withDirectives(_createVNode(_component_Breadcrumb, {
    class: "breadcrumb",
    breadcrumbData: $setup.breadcrumbData
  }, null, 8, ["breadcrumbData"]), [[_vShow, $setup.isFinishQuery]]), _withDirectives(_createVNode(_component_ViewMode, {
    modelValue: $setup.viewMode,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $setup.viewMode = $event)
  }, null, 8, ["modelValue"]), [[_vShow, $setup.isFinishQuery && $setup.isShowVideMode]]), _createVNode(_component_el_skeleton, {
    animated: "",
    loading: !$setup.isFinishQuery
  }, {
    template: _withCtx(() => [_createVNode(_component_el_skeleton_item, {
      variant: "h3",
      style: {
        "max-width": "500px"
      }
    })]),
    _: 1
  }, 8, ["loading"])]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "rl-hidden-desktop rl-row-10"
  }, null, -1)), _createVNode(_component_el_divider, {
    class: "rl-hidden-mobile"
  })]), _createVNode(_component_List, {
    groupData: $setup.groupData,
    viewMode: $setup.viewMode,
    toExcludeLegacy: true,
    impressionHandler: $setup.impressionGAtrack,
    clickCardHandler: $setup.clickGAtrack,
    scrollToBottomHandler: $setup.getCourseData,
    clickBookmarkHandler: $setup.updateBookmarkStatus,
    isLastPage: $setup.isLastPage,
    isFinishQuery: $setup.isFinishQuery,
    langPath: $setup.getLanguagePath(),
    dataPreprocessHandler: $setup.preprocessData,
    errorMsg: $setup.listErrorMsg
  }, null, 8, ["groupData", "viewMode", "impressionHandler", "clickCardHandler", "scrollToBottomHandler", "clickBookmarkHandler", "isLastPage", "isFinishQuery", "langPath", "dataPreprocessHandler", "errorMsg"])], 64);
}